/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import { prettifyData } from "./util/helpers";
import {
	SET_CURRENT_INDEX,
	SAVE_FIELD_DATA_SUCCESS,
	COMPONENT_MOUNTED,
} from "ducks/what_i_want";

import {
	FIELDS,
	FIELD_NAVIGATION,
	MONOGAMY_LABELS,
	RELATIONSHIP_STATUS_LABELS,
} from "apps/what_i_want/util/constants";

import UrlHelpers from "shared/util/UrlHelpers";

import { isNonMonogamyReboarding } from "apps/what_i_want/util/helpers";

// ------------------------- helpers -------------------------
const _valueMap = {
	ageMin: "desired min age",
	ageMax: "desired max age",
	distance: "desired distance",
	isMetric: "unit system",
	lookingfor: "desired relationship",
	genders: "desired genders",
	monogamy: "monogamy",
	relationshipStatus: "relationship status",
};

const _fieldMap = {
	[FIELDS.LOOKINGFOR]: "lookingfor",
	[FIELDS.GENDER]: "genders",
	[FIELDS.DISTANCE]: ["distance", "isMetric"],
	[FIELDS.AGE]: ["ageMin", "ageMax"],
	[FIELDS.MONOGAMY]: "monogamy",
	[FIELDS.RELATIONSHIP_STATUS]: "relationshipStatus",
};

const _updatedLookingForValues = {
	"long_term_dating": "long-term dating",
	"casual_sex": "hookup",
	"short_term_dating": "short-term dating",
	"new_friends": "new friends",
};

const _fieldToAnalyticsName = {
	[FIELDS.LOOKINGFOR]: Analytics.eventNames.updatedConnectionsWiwPreferences,
	[FIELDS.GENDER]: Analytics.eventNames.updatedGenderWiwPreferences,
	[FIELDS.DISTANCE]: Analytics.eventNames.updatedDistanceWiwPreferences,
	[FIELDS.AGE]: Analytics.eventNames.updatedAgeRangeWiwPreferences,
};

function _parseLookingForValues(values) {
	const updatedValues = [];

	values.forEach((value) => {
		if (_updatedLookingForValues[value]) {
			updatedValues.push(_updatedLookingForValues[value]);
		}
	});

	return updatedValues.sort();
}

function _getFieldData(field, fieldValues) {
	const inputField = _fieldMap[field];

	if (Array.isArray(inputField)) {
		const inputs = {};

		inputField.forEach((input) => {
			let inputValue = fieldValues[input];

			if (input === "isMetric") {
				inputValue = fieldValues[input] ? "metric" : "imperial";
			}

			inputs[_valueMap[input]] = prettifyData(inputValue);
		});

		return inputs;
	} else if (field === FIELDS.LOOKINGFOR) {
		return {
			[_valueMap[inputField]]: _parseLookingForValues(fieldValues[inputField]).join(", "),
		};
	} else if (field === FIELDS.MONOGAMY) {
		return {
			[_valueMap[inputField]]: MONOGAMY_LABELS[fieldValues[inputField]],
		};
	} else if (field === FIELDS.RELATIONSHIP_STATUS) {
		return {
			[_valueMap[inputField]]: RELATIONSHIP_STATUS_LABELS[fieldValues[inputField]],
		};
	} else {
		return {
			[_valueMap[inputField]]: prettifyData(fieldValues[inputField]),
		};
	}
}

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function whatIWant(state, action) {
	switch (action.type) {
		case SET_CURRENT_INDEX: {
			if (action.direction !== FIELD_NAVIGATION.NEXT) {
				return;
			}

			const fieldsToCheckReboarding = new Set([
				FIELDS.MONOGAMY,
				FIELDS.RELATIONSHIP_STATUS,
			]);

			const { currentField } = state;
			const eventName = Analytics.eventNames.getOnboardingStepEventName(currentField);
			const fieldResponse = _getFieldData(currentField, state.fieldValues);

			if (!eventName) {
				return;
			}

			if (fieldsToCheckReboarding.has(currentField)) {
				fieldResponse.reboarding = isNonMonogamyReboarding();
			}

			Analytics.logUIEvent(
				eventName,
				{ data: fieldResponse },
			);

			return;
		}

		case SAVE_FIELD_DATA_SUCCESS: {
			if (!state.entryPoint || state.entryPoint !== "onboarding") {
				Analytics.logUIEvent(Analytics.eventNames.savedPreferencesOnMyMatch);
			}

			const cameFrom = UrlHelpers.getParam("cf");
			const { currentField, fieldValues } = action.payload;

			if (cameFrom === "unified settings") {
				Analytics.logUIEvent(
					_fieldToAnalyticsName[currentField], {
						data: {
							..._getFieldData(currentField, fieldValues),
							source: cameFrom,
						},
					},
				);
			}

			return;
		}

		case COMPONENT_MOUNTED: {
			if (!action.entryPoint || action.entryPoint !== "onboarding") {
				Analytics.logUIEvent(Analytics.eventNames.selectedMyMatchOnSettingsHome);
			}

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/what_i_want.js